module.exports = __webpack_public_path__ + "img/shouji.54699bf3.png";